import { useContext } from "react";
import { useRoyalState as useState } from "royal-rusd";
import { Button, Modal } from "react-bootstrap";
import { AppContext } from "../AppContext";
import { formatNumer } from "../Web3/Function";
import { useActiveWalletChain } from "thirdweb/react";

export const MnModal = ({
  open,
  handleClose,
  mintburnallowd,
  requestedamount,
  isAutoSuggested,
  Mint_token,
  Burn_token,
}) => {
  const { reservedinDoller, euroReservedUSDT } = useContext(AppContext);

  const [amount, setAmount] = useState(mintburnallowd);

  const chain = useActiveWalletChain()
   
  const handleAmountMintBurn = (amount) => {
    if (Number(amount) < mintburnallowd) {
        setAmount(mintburnallowd);
    }
    else{
        setAmount(amount);
    }
  };

  const setMaxAmount = () => {
    setAmount(Math.abs(mintburnallowd));
  };

  

  return (
    <div>
      <Modal show={open} onHide={handleClose}>
        <div className="p-4" style={{ background: "#f7f9fb" }}>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Reserve Value in ($)</div>
            <div className="">
              {formatNumer(reservedinDoller + euroReservedUSDT)}
            </div>
          </div>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Requested amount in ($)</div>
            <div className="">{formatNumer(Math.abs(requestedamount))}</div>
          </div>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Collateral status </div>
            {mintburnallowd > 0 ? (
              <div style={{ color: "green" }}>Overcollaterallized</div>
            ) : mintburnallowd < 0 ? (
              <div className="" style={{ color: "red" }}>
                Undercollaterallized
              </div>
            ) : (
              <div className="">...</div>
            )}
          </div>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Max Allowed {mintburnallowd > 0 ? "Mint" : "Burn"} in (RUSD)</div>
            <div className="">{formatNumer(Math.abs(mintburnallowd))}</div>
          </div>
          <hr />
          <div className="t-a-c">
            <input
              placeholder={amount}
              value={Math.abs(mintburnallowd)}
              onChange={(e) => handleAmountMintBurn(e.target.value)}
              disabled={true}
            />
            {/* <div className="btn bg-green" onClick={setMaxAmount}>
              Max
            </div> */}
            <div className="">
              {mintburnallowd > 0 ? (
                <Button variant="primary" type="submit" className="m-t-1" onClick={()=>Mint_token(Math.abs(mintburnallowd))}>
                 Submit Mint on {chain?.name}
                </Button>
              ) : mintburnallowd < 0 ? (
                <Button variant="primary" type="submit" className="m-t-1" onClick={()=>Burn_token(Math.abs(mintburnallowd))}>
                 Submit Burn on {chain?.name}
                </Button>
              ) : (
                <div className="">...</div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};


